<template>
	<div>
		<div class="store-list">
			<p>
				{{ stores.length }} stores in the area
			</p>
			<store-summary
				v-for="store in pages[page - 1]"
				:store="store"
				:key="store.id"
				class="store-item"
			/>
			<nav class="store-list-pagination flex flex-between" v-if="pages.length > 1">
				<a href="javascript:void(0)" @click="paginate(page - 1)" :class="{'disabled': page <= 1}">
					<i class="fa fa-chevron-left"></i> Prev
				</a>
				<div>Page {{ page }} of {{ pages.length }}</div>
				<a href="javascript:void(0)" @click="paginate(page + 1)" :class="{'disabled': page >= pages.length}">
					Next <i class="fa fa-chevron-right"></i>
				</a>
			</nav>
			<ui-button
				href="/stores/"
				size="sm"
				color="soft-blue-outline"
				style="max-width: 100%;"
			>
				View All Stores
			</ui-button>
		</div>
	</div>
</template>

<script>
import StoreSummary from './StoreSummary.vue';
export default {
	name: 'StoreList',
	props: {
		stores: {
			type: Array,
			required: true
		}
	},
	components: { StoreSummary },
	computed: {
		pages() {
			if (!this.stores) return [[]];
			const pages = [[]];
			let page = 0;
			for (let i = 0; i < this.stores.length; i++) {
				if (!pages[page]) pages[page] = [];
				pages[page].push(this.stores[i]);
				if ((i + 1) % 4 === 0) page++;
			}
			return pages;
		}
	},
	data() {
		return {
			page: 1
		};
	},
	methods: {
		paginate(page) {
			if (page > this.pages.length || page < 1) return;
			this.page = page;
		}
	},
	watch: {
		stores(newVal, oldVal) {
			this.page = 1;
		}
	}
};
</script>

<style lang='less' scoped>
@import '../../../less/_mixins.less';
.store-list {
	padding: 17px 15px;
	.ms-styles({
		padding: 10 15px;
	});
	p {
		color: #6671A3;
		font-size: 18px;
		font-weight: bold;
		margin: 0;
		padding: 0;
		.mobile-styles({
			font-size: 14px;
		});
	}
}
.store-list-pagination {
	margin-bottom: 25px;
	font-size: 14px;
	i {
		font-size: 12px;
	}
	a.disabled {
		opacity: 0.5;
	}
}
</style>